module.exports = ({ productId, path = '/details/' }) => {
  const host = typeof process === 'undefined' ? undefined : process.env.HOST

  return `${host ? `https://${host}` : ''}/api/system/products/${productId}${path}`
}
